import FootballState from "../../../../state/football-state";
import FootballStatsCategory from "../../../../stats/football-stats-category";
import StatsRule from "../../../../../common/stats-rule";

export default class KickOffStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.KickOff &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { kickedBy, kickedFrom, id } =
            play.getFirstFragment(FootballState.Kick) || {};
        const yardsKicked =
            (fragment.kickedTo - kickedFrom) *
            gameContext.getFieldDirectionMultiplier();
        const touchbackFragment = play.getFirstFragment(
            FootballState.TouchBack
        );
        const rougeFragment = play.getFirstFragment(FootballState.Rouge);

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: kickedBy?.teamId,
            playerId: kickedBy?.id,
            driveId: gameContext.currentDriveId,
            fragmentId: id,
            category: FootballStatsCategory.KICK_OFF,
            values: {
                yards: yardsKicked,
                completed: 1,
                attempted: 1,
                touchback: touchbackFragment ? 1 : 0,
                rouge: rougeFragment ? 1 : 0
            }
        });
    }
}
